import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ReportScreenshot } from '../../../store/models/reports';
import { toFitWidthThumbnailUrl } from './pdfViewerUrl';

interface SortableImageProps {
  id: string;
  report: ReportScreenshot;
  aspectRatio?: string;
  // Chart screenshots get fit-to-width so the chart isn't cropped in the
  // small card; uploaded PDF pages are left at the viewer's own default.
  isChart?: boolean;
}

export const SortableImageV2 = ({ id, report, aspectRatio = '8.5 / 11', isChart = false }: SortableImageProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={{ ...style, aspectRatio }}
      {...attributes}
      {...listeners}
      className="relative overflow-hidden rounded border border-strokedark bg-white"
    >
      <iframe
        src={isChart ? toFitWidthThumbnailUrl(report.image) : report.image}
        style={{
          height: '100%',
          width: '100%',
          border: 'none',
          pointerEvents: 'none', // Prevents iframe from interfering with drag
        }}
      />
    </div>
  );
}
